// src/utils/pulse.js
//
// The weekly-pulse gate, in one place. DashboardView uses it for the frosted
// lock screen; App uses it to hide the AI Coach while that screen is up, so
// nothing pokes through the blur and the only way forward is the pulse.

export const PULSE_INTERVAL_DAYS = 7;

// A pulse is due when there's a baseline but the last pulse is missing or
// older than the interval. (No baseline -> the assessment gate applies instead.)
export const isPulseDueFor = (user, hasData) => {
    if (!hasData) return false;
    if (!user?.lastPulseDate) return true;
    const diffDays = (new Date() - new Date(user.lastPulseDate)) / (1000 * 60 * 60 * 24);
    return diffDays >= PULSE_INTERVAL_DAYS;
};

// Dashboard content renders ONLY with a baseline AND a fresh weekly pulse.
// Preview mode bypasses the gate (a previewed persona has no persisted
// assessment, so it could never clear).
export const isDashboardLocked = ({ user, hasData, isPreviewMode }) =>
    !isPreviewMode && (!hasData || isPulseDueFor(user, hasData));
